import styled from 'styled-components';
import { Grid } from '@material-ui/core';

const GridLeft = styled(Grid)`
  border-right: 1px solid rgba(0, 0, 0, 0.24);
  text-align: right;
`;

export default GridLeft;
